module.exports = __webpack_public_path__ + "static/media/cw.fa095496.svg";